"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyFund = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var zl_1 = require("../../model/zl");
var service_1 = require("../../../library/base/service");
var MyFund = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(MyFund, _super);
    function MyFund() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '我的基金';
        _this.code = '106012';
        _this.desc = '我的基金';
        _this.requestParams = new zl_1.MyFundRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return MyFund;
}(service_1.BaseService));
exports.MyFund = MyFund;
//# sourceMappingURL=myFund.js.map